import * as React from 'react'

import { Box, Dimensions } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export type ExpensesListPageLayoutProps = {
  children: React.ReactNode
  /**
   * Padding for the layout container.
   * DataTable (deprecated) requires padding, DataCollection handles its own.
   */
  padding?: Dimensions
}

/**
 * Layout wrapper for ExpensesListPage that enables proper flexbox-based footer positioning.
 *
 * ## Why this pattern exists
 *
 * The `SyncFooter` component needs to be positioned at the bottom of the viewport,
 * not at the end of scrollable content. This requires a flex column layout with
 * proper height constraints.
 *
 * However, `ResponsivePage.Body`'s internal `Container` component has `overflow: auto`
 * without a height constraint, which breaks the CSS height chain. When wrapped by
 * `ResponsivePage.Body`, our `height: 100%` becomes 100% of "auto" (content height),
 * making the flexbox layout ineffective.
 *
 * ## The solution
 *
 * We render `ResponsivePage.Body` hidden (to maintain framework integration like
 * error boundaries), then render our layout Box as a sibling. This bypasses the
 * Container's height issues while preserving framework functionality.
 *
 * This pattern is also used by the Compensations team:
 * @see frontend/src/modules/compensations/pages/CompensationsPayrollRun/Layout.tsx
 */
export const ExpensesListPageLayout = ({ children, padding }: ExpensesListPageLayoutProps) => {
  return (
    <>
      <Box className="hidden">
        <ResponsivePage.Body variant="fullscreen">&nbsp;</ResponsivePage.Body>
      </Box>
      <Box padding={padding} height="full">
        {children}
      </Box>
    </>
  )
}
